import { render, staticRenderFns } from "./Template.vue?vue&type=template&id=06db0b65&scoped=true&"
import script from "./FacturaEdit.vue?vue&type=script&lang=js&"
export * from "./FacturaEdit.vue?vue&type=script&lang=js&"
import style0 from "./FacturaEdit.scss?vue&type=style&index=0&id=06db0b65&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06db0b65",
  null
  
)

export default component.exports